import React from "react";
import s from "../css/labeltypetabs.module.scss";
import { usePermission } from "context/PermissionContext";
import { PERMISSION_MODULES } from "common/constants/PermissionConstants";

/* --------------------------------
Types
--------------------------------- */

export type PrintTabKey = "subject" | "icard" | "vacutainer" | "cryovial" | "box" | "dispensing";

export interface PrintTab {
  key: PrintTabKey;
  label: string;
  icon: string;
  path: string;
}

/* ─────────────────────────────────────────────────────────────
   TYPES
───────────────────────────────────────────────────────────── */

export type LabelTab = "subject" | "vacutainer" | "cryovial" | "box" | "dispensing" | "idcard";

interface LabelTypeTabsProps {
  activeTab: LabelTab;
  onTabChange: (tab: LabelTab) => void;
}

/* ─────────────────────────────────────────────────────────────
   TAB CONFIG
───────────────────────────────────────────────────────────── */

const TABS: { key: LabelTab; label: string; icon: string }[] = [
  { key: "subject",    label: "Subject Label",           icon: "ri-user-line" },
  { key: "idcard",     label: "Subject ID Card",         icon: "ri-profile-line" },
  { key: "vacutainer", label: "Vacutainer Label",        icon: "ri-flask-line" },
  { key: "cryovial",   label: "Cryovial/Riavial Label",  icon: "ri-test-tube-line" },
  { key: "box",        label: "Box Label",               icon: "ri-archive-drawer-line" },
  { key: "dispensing", label: "Dispensing Label",        icon: "ri-price-tag-3-line" },
];

const permissionMap: Record<LabelTab, string> = {
  subject: PERMISSION_MODULES.SUBJECT_LABEL,
  idcard: PERMISSION_MODULES.SUBJECT_ICARD_LABEL,
  vacutainer: PERMISSION_MODULES.VACUTAINER_LABEL,
  cryovial: PERMISSION_MODULES.RIAVIAL_LABEL,
  box: PERMISSION_MODULES.RIAVIAL_LABEL,
  dispensing: PERMISSION_MODULES.DISPENSING_LABEL,
};

/* ─────────────────────────────────────────────────────────────
   COMPONENT
───────────────────────────────────────────────────────────── */

const LabelTypeTabs: React.FC<LabelTypeTabsProps> = ({ activeTab, onTabChange }) => {
  const { hasPermission, isModuleVisible } = usePermission();

  const filteredTabs = TABS.filter(({ key, label }) => {
    const moduleName = permissionMap[key];
    return hasPermission(moduleName) && isModuleVisible(moduleName);
  });

  return (
    <div className={s.tabContainer}>
      {filteredTabs.map(({ key, label, icon }) => (
        <button
          key={key}
          type="button"
          onClick={() => onTabChange(key)}
          className={`${s.tabBtn} ${activeTab === key ? s.active : ""}`}
        >
          <i className={icon} />
          {label}
        </button>
      ))}
    </div>
  );
};

export default LabelTypeTabs;
